import { useCallback } from 'react'
import { UserSelectUser } from '../types'

/**
 * a callback to transform a user into the tooltip property for the UserSelect's
 * LabeledValueType
 */
export function useUserSelectTooltip() {
  const callback = useCallback<
    (user: UserSelectTooltipUser) => string | null | undefined
  >(({ displayName, mail }) => {
    if (!!displayName) return mail
    return undefined
  }, [])

  return callback
}

export type UserSelectTooltipUser = Pick<
  UserSelectUser,
  '__typename' | 'displayName' | 'mail'
>
